import styled from 'styled-components';

export const SubHeader = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;

`;